import React from 'react'
import ProjectHeader from './header/project/project'
import TopHeaderNavigationDeprecated from "./header/header-navigation/navigation"
import PortfolioHeader from "./header/portfolio/portfolio-header"
import UserHeader from './header/user/user'
import CompanyHeader from '../../app/ui/top/company/company'

type Props = {
    app: any
}

type State = {
    projectId           : ID | null,
    projectCollectionId : ID | null,
    companyUserId       : ID | null,
    companyId           : ID | null,
    extensions          : any | null,
    curMenuId           : ID | null,
    sectionName         : string | null,
    showIcon            : boolean, //true,
    appName             : string | false,
    navigation          : any | false        // custom navigation
    menuComponent?      : any
    isExtentionsDisabled?   : boolean
    appIcon?                : string
}

const debug = false
// const debug = "TopMain"

export default class TopMain extends React.Component<Props, State> {


    public onExtensionsDisabledClick    : any

    constructor(props:Props) {
        super(props);

        this.state = {
            projectId           : null,
            projectCollectionId : null,
            companyUserId       : null,
            companyId           : null,
            extensions          : null,
            curMenuId           : null,
            // additionalPath      : null,
            sectionName         : null,
            showIcon            : true,
            appName             : false,
            navigation          : false        // custom navigation
        };
    }



    componentDidMount() {
        gd.top.registerComponent(this);
    }

    loadChunk = (tps:any, callback:callback) => {
        const isTemplate = tps.projectId ? !!gd.session.projects.get(tps.projectId)!.isTemplate : false;

        // test new
        callback();
    };

    // tps = topPanelSettings....
    update = (tps:any) => {
        if (!tps) tps = {};
        const newValue = {
            projectId           : tps.projectId ?               tps.projectId           : null,
            projectCollectionId : tps.projectCollectionId ?     tps.projectCollectionId : null,
            companyId           : tps.companyId ?               tps.companyId           : null,
            companyUserId       : tps.companyUserId ?           tps.companyUserId       : null,
            extensions          : tps.extensions ?              tps.extensions          : null,
            curMenuId           : tps.curMenuId ?               tps.curMenuId           : null,
            // additionalPath      : tps.additionalPath ?          tps.additionalPath      : null,
            menuComponent       : tps.menuComponent?            tps.menuComponent       : null,
            sectionName         : tps.sectionName ?             tps.sectionName         : null,
            showIcon            : !_.isNil(tps.showIcon) ?      tps.showIcon            : true,
            appName             : _.get(tps, 'appName', false),
            appIcon             : _.get(tps, 'appIcon', false),
            navigation          : _.get(tps, 'navigation', false)
        };

        this.loadChunk(tps, ()=>{
            this.setState(newValue);
        });
    };

    renderExtensions = () => {
        if (this.state.extensions) {
            const renderFunction = this.state.extensions[1];
            const isDisabled = this.state.isExtentionsDisabled;

            const classes = Classes('extensions',{
                disabled: isDisabled
            });

            return (
                <div className={classes}>
                    {renderFunction()}
                    {isDisabled &&
                    <div className="disabled-screen" onClick={this.onExtensionsDisabledClick}> </div>}
                </div>
            )
        }
    }

    reRender() {
        if (this.state.menuComponent) {
            gd.bus.triggerEvent('top-menu-component:reRender')
        } else {
            this.forceUpdate()
        }
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        if (this.state.projectId) {

            if (gd.teamsWidget && gd.teamsWidget.isProjectView) return false;

            return (
                <div className="ui-top">
                    <ProjectHeader />
                    {this.renderExtensions()}
                </div>
            );
        }

        if (this.state.projectCollectionId) {
            return (
                <div className="ui-top">
                    <PortfolioHeader app={this.props.app} />
                    {this.renderExtensions()}
                </div>
            );
        }

        if (this.state.companyUserId) {
            return (
                <div className="ui-top">
                    <UserHeader companyUserId   = {this.state.companyUserId}
                                curMenuId       = {this.state.curMenuId} />
                    {this.renderExtensions()}
                </div>
            );
        }

        if (this.state.appName) {
            return (
                <div className="ui-top">
                    <TopHeaderNavigationDeprecated name         = {this.state.appName}
                                                   icon         = {this.state.appIcon}
                                                   navigation   = {this.state.navigation}
                                                   editable     = {true}
                                                   onChange     = {()=>{}}/>
                    {this.renderExtensions()}
                </div>
            )
        }

        let res = <div className="empty-top"/>;

        if (this.state.menuComponent) {
            res = this.state.menuComponent;
        } else if (this.state.companyId) {
            res = <CompanyHeader companyId={this.state.companyId}
                                 extensions={this.state.extensions}
                                 curMenuId={this.state.curMenuId}
                                 sectionName={this.state.sectionName}
                                 showIcon={this.state.showIcon}/>
        }

        debug && console.log(debug, 'render res', res)

        return res;
    }


}